/* eslint-disable no-unused-vars */
import * as THREE from "three";
import * as TWEEN from "@tweenjs/tween.js";
import { throttle, isEmpty } from "lodash";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import Stats from "three/examples/jsm/libs/stats.module";
// import * as dat from "dat.gui";
import {
  ANIMATION_EVENTS,
  ASSET_TYPES,
  SCENE_EVENTS,
  THREEJS_NAMES,
} from "../constants";
import Event from "./Event";
import RaycasterHelper from "./RaycasterHelper";
import HotspotHelper from "./HotspotHelper";

// const gui = new dat.GUI();
// const debugObject = {}

const RESIZE_UPDATE_INTERVAL = 500;

const mod = () => {
  let scene = null;
  let shadowLight = null;
  let newBoxSize;
  let renderer = null;
  let camera = null;
  let orbitControls = null;
  let stats = null;
  let renderFlag = true;
  let sceneCreate = false;
  let sceneAddedToDom = false;
  let sceneHidden = false;
  let onFloor = true;
  let animate = () => {};
  const raycaster = new THREE.Raycaster();
  let hotspotsEnabled = false;
  const windowActive = true;
  const centerAndScaleModelObject = {
    gltfObject: null,
    boxSize: null,
  };
  let updateHelpers = false;
  const currentEnvironmentLight = null;
  const resizeCanvasToDisplaySize = () => {
    const canvas = renderer.domElement;
    // look up the size the canvas is being displayed
    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    console.log(
      "resizeCanvasToDisplaySize",
      width,
      height,
      canvas.width,
      canvas.height
    );
    // adjust displayBuffer size to match
    if (canvas.width !== width || canvas.height !== height) {
      // you must pass false here or three.js sadly fights the browser
      renderer.setSize(width, height, false);
      camera.aspect = width / height;
      camera.updateProjectionMatrix();

      // update any render target sizes here
    }
  };

  const centerAndScale = (gltfObject, boxSize) => {
    console.log("center and scale called", gltfObject, boxSize);
    if (!gltfObject) return;
    if (!boxSize) {
      boxSize = newBoxSize;
    }
    const maxSide = Math.max(boxSize.x, Math.max(boxSize.y, boxSize.z));
    console.log("Anshul", maxSide);
    const defaultNear = maxSide / 100;
    const defaultFar = maxSide * 100;
    centerAndScaleModelObject.gltfObject = gltfObject;
    centerAndScaleModelObject.boxSize = boxSize;
    const canvas = renderer.domElement;
    const aspect = canvas.clientWidth / canvas.clientHeight;
    const aspectMain = window.innerWidth / window.innerHeight;
    // const vFOV = (camera.fov * Math.PI) / 180;
    // const radiusSphere =
    //   Math.sqrt(boxSize.x ** 2 + boxSize.y ** 2 + boxSize.z ** 2) / 2;
    // console.log(maxSide, "boxSide");
    // let zSphere = 1.2 * (radiusSphere / Math.sin(vFOV / 2) / aspect);
    // // console.log("dimensionanshul",window.innerHeight);
    // if (window.innerHeight < 500) {
    //   zSphere += 2 * (1 - (window.innerHeight / 500) ** 2);
    // }
    // if (onFloor) camera.position.set(-zSphere / 2, zSphere / 2, zSphere);
    // else camera.position.set(-zSphere / 2, -zSphere / 2, zSphere);

    const bufferPercent = 0.75;
    const vFOV = ((camera.fov * Math.PI) / 180) * bufferPercent;
    const hFOV =  2 * Math.atan(aspect * Math.tan(vFOV / 2));
  
    // console.info("chek fovVH", vFOV, hFOV);
  
    const dist1 = boxSize.y / 2 / Math.tan(vFOV / 2) * 1.25;    
    const dist2 = (boxSize.x / 2 / Math.tan(hFOV / 2)) * 0.75;

    // console.info("chek 12", dist1, dist2);
    const dist =  Math.max(dist1, dist2);
    
    const r2 = Math.sqrt(2);

    if (onFloor) camera.position.set(-dist / r2, dist / r2, dist * r2);
    else camera.position.set(-dist / r2, - dist / r2, dist * r2);
        
    camera.far = defaultFar;
    camera.near = defaultNear;
    camera.updateProjectionMatrix();
    console.log(
      "center and scale called box3",
      window.innerHeight,
      window.innerWidth,
      canvas.clientWidth,
      canvas.clientHeight,
      vFOV,
      camera.position
    );
    Event.sendSMEvent(ANIMATION_EVENTS.CENTER_SCALE_COMPLETE, {});
  };
  // const updateAllMaterial = () =>
  // {
  //   scene.traverse((child)=>{
  //     if(child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial){
  //       child.material.envMapIntensity = debugObject.envMapIntensity
  //       child.material.needsUpdate = true
  //     }
  //   })
  // }
  const addEnvironmentLight = (
    sceneArg,
    rendererArg,
    environmentLightConfig,
    getAssetCallback
  ) => {
    if (!sceneArg?.children || !rendererArg) return;
    if (!environmentLightConfig) return;
    if (environmentLightConfig?.name) {
      const lightTexture = getAssetCallback(environmentLightConfig?.lightURL);
      console.log("appplyuing environment light", environmentLightConfig);
      const pmremGenerator = new THREE.PMREMGenerator(rendererArg);
      let envMap = null;
      if (environmentLightConfig.type === ASSET_TYPES.CUBE_MAP) {
        pmremGenerator.compileCubemapShader();
        envMap = pmremGenerator.fromCubemap(lightTexture)?.texture;
      } else {
        pmremGenerator.compileEquirectangularShader();
        envMap = pmremGenerator.fromEquirectangular(lightTexture).texture;
      }
      // sceneArg.background = envMap;
      envMap.encoding = THREE.sRGBEncoding;
      sceneArg.environment = envMap;
      // debugObject.envMapIntensity = 5
      // gui.add(debugObject,'envMapIntensity').min(0).max(10).step(0.001).onChange(updateAllMaterial)
      // sceneArg.background = envMap;
      pmremGenerator.dispose();
      // rendererArg.toneMapping = environmentLightConfig.toneMapping;
      // rendererArg.toneMappingExposure = environmentLightConfig.exposure;
    }
  };

  const windowResizeListener = throttle(
    () => {
      resizeCanvasToDisplaySize();
      centerAndScale(
        centerAndScaleModelObject.gltfObject,
        centerAndScaleModelObject.boxSize
      );
    },
    RESIZE_UPDATE_INTERVAL,
    { trailing: true }
  );

  const windowClicked = (event) => {
    if (!hotspotsEnabled) return;
    const normalizedClickPos = {
      x: (event.clientX / window.innerWidth) * 2 - 1,
      y: -(event.clientY / window.innerHeight) * 2 + 1,
    };
    const intersectedObjects = RaycasterHelper.checkIntersection(
      camera,
      normalizedClickPos
    );
    Object.keys(intersectedObjects).forEach((modelId) => {
      HotspotHelper.addHotspot(modelId, intersectedObjects[modelId]);
    });
    // HotspotHelper.addHotspot();
    console.log("intersected", intersectedObjects);
  };

  // const removeCanvasIfPresent = (mode) => {
  //   if (document.getElementById("SCENE")) {
  //     if (mode === "engine") {
  //       const rendererDiv = document.getElementById("RENDERER");
  //       rendererDiv.removeChild(document.getElementById("SCENE"));
  //     } else {
  //       const rendererDiv = document.getElementsByClassName("renderer")[0];
  //       rendererDiv.removeChild(document.getElementById("SCENE"));
  //     }
  //     console.log("RemoveCanvasIfPresent");
  //   }
  // };

  const removeStatsIfPresent = () => {
    const statsDom = document.getElementById(THREEJS_NAMES.STATS);
    if (statsDom != null) {
      // statsDom.remove();
      document.body.removeChild(statsDom);
    }
  };

  return {
    divresize: () => resizeCanvasToDisplaySize(),
    getCamera: () => camera,
    enableRenderLoop: () => {
      renderFlag = true;
      animate();
    },
    addOpacity: () => {
      const element = document.getElementById(THREEJS_NAMES.SCENE_NAME);
      if (element != null) {
        // element.remove();
        element.style.opacity = 1;
      }
      renderFlag = true;
      // centerAndScale(
      //   centerAndScaleModelObject.gltfObject,
      //   centerAndScaleModelObject.boxSize
      // );
      animate();
    },
    getSceneCreate: () => sceneCreate,
    getSceneAddedToDom: () => sceneAddedToDom,
    getSceneHidden: () => sceneHidden,
    enableHotspotTracking: () => {
      hotspotsEnabled = true;
    },
    disableHotspotTracking: () => {
      hotspotsEnabled = false;
    },
    changeBackgroundColor: (sceneArg, color, mode) => {
      if (mode !== "ar") sceneArg.background.set(color);
    },
    createScene: () => {
      if (sceneCreate) return;
      // removeCanvasIfPresent(mode);
      // const canvas = document.createElement("canvas");
      // canvas.id = "SCENE";
      // if (mode === "engine") {
      //   const rendererDiv = document.getElementById("RENDERER");
      //   rendererDiv.insertBefore(canvas, rendererDiv.firstChild);
      //   canvas.classList.add("SCENE-engine");
      // } else {
      //   const rendererDiv = document.getElementsByClassName("renderer")[0];
      //   rendererDiv.appendChild(canvas);
      //   canvas.classList.add("SCENE");
      // }
      const canvas = document.getElementById(THREEJS_NAMES.SCENE_NAME);
      canvas.style.opacity = 1;
      renderer = new THREE.WebGLRenderer({
        canvas,
        antialias: true,
        powerPreference: "high-performance",
      });

      renderer.physicallyCorrectLights = true;
      renderer.outputEncoding = THREE.sRGBEncoding;
      renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
      renderer.shadowMap.enabled = true;
      renderer.shadowMap.type = THREE.VSMShadowMap;

      // gui.add(renderer,'toneMapping',{
      //   No: THREE.NoToneMapping,
      //   Linear: THREE.LinearToneMapping,
      //   Reinhard: THREE.ReinhardToneMapping,
      //   Cineon: THREE.CineonToneMapping,
      //   ACESFilmic: THREE.ACESFilmicToneMapping
      // })
      // .onFinishChange(()=>{
      //   renderer.toneMapping = Number(renderer.toneMapping)
      //   updateAllMaterial()
      // })

      // gui.add(renderer,'toneMappingExposure').min(0).max(10).step(0.001)

      scene = new THREE.Scene();
      scene.background = new THREE.Color(0xffffff);
      const aspect = window.innerWidth / window.innerHeight;
      camera = new THREE.PerspectiveCamera(45, aspect, 0.01, 1000);
      renderer.outputEncoding = THREE.sRGBEncoding;

      const clock = new THREE.Clock();

      let delta = clock.getDelta();

      const interval = 1 / 30;
      animate = () => {
        if (renderFlag === true) requestAnimationFrame(animate);
        delta += clock.getDelta();
        if (delta > interval) {
          if (!windowActive) {
            return;
          }
          if (scene == null || renderer == null) return;
          // if (stats) stats.update();
          if (orbitControls) {
            orbitControls.update();
          }
          if (hotspotsEnabled) HotspotHelper.updateHotspots(camera);
          if (updateHelpers) {
            scene.children.forEach((obj) => {
              if (obj.name === THREEJS_NAMES.BOX_HELPER) {
                obj.setFromObject(obj.modelObject);
              }
            });
          }
          TWEEN.update();
          renderer.render(scene, camera);

          delta %= interval;
        }
      };
      sceneCreate = true;
      Event.sendSMEvent(SCENE_EVENTS.SCENE_READY, {});
    },
    addSceneToDOM: () => {
      if (renderer == null) return;
      const element = document.getElementById(THREEJS_NAMES.SCENE_NAME);
      if (element != null) {
        // element.remove();
        element.style.visibility = "visible";
      }
      if (sceneAddedToDom) return;
      // window.addEventListener("resize", windowResizeListener);
      window.addEventListener("click", windowClicked);
      // window.addEventListener("blur", (e) => {
      //   console.log("visibility change blur", e);
      //   windowActive = false;
      // });
      // window.addEventListener("focus", (e) => {
      //   console.log("visibility change focus", e);
      //   windowActive = true;
      // });
      removeStatsIfPresent();
      stats = Stats();
      stats.dom.id = THREEJS_NAMES.STATS;
      stats.dom.style.cssText =
        "position: fixed; top: 0px; right: 0px; cursor: pointer; opacity: 0.9; z-index: 10000;";
      // document.body.appendChild(stats.dom);
      requestAnimationFrame(animate);
      resizeCanvasToDisplaySize();
      sceneAddedToDom = true;
    },
    hideScene: (hide) => {
      const element = document.getElementById(THREEJS_NAMES.SCENE_NAME);
      if (element != null) {
        element.style.visibility = hide ? "hidden" : "visible";
      }
      sceneHidden = true;
    },

    removeSceneFromDOM: () => {
      // Cleanup example: https://threejsfundamentals.org/threejs/lessons/threejs-cleanup.html
      // window.removeEventListener("resize", windowResizeListener);
      const element = document.getElementById(THREEJS_NAMES.SCENE_NAME);
      if (element != null) {
        // element.remove();
        element.style.opacity = 0;
      }
      renderFlag = false;

      // const statsDom = document.getElementById(THREEJS_NAMES.STATS);
      // if (statsDom != null) {
      //   // statsDom.remove();
      //   document.body.removeChild(statsDom);
      // }

      // if (orbitControls != null) {
      //   orbitControls = null;
      // }
      // if (renderer != null) {
      //   renderer.clear();
      //   renderer.dispose();
      //   renderer = null;
      // }
      // animate = () => {};
      // sceneAddedToDom = false;
      // sceneCreate = false;
    },
    getSceneDetails: () => ({ scene, camera, renderer }),
    setCameraConfig: (config) => {
      if (camera == null || config == null) return;
      // Update the camera attributes
      const attrs = {};
      [
        "aspect",
        "fov",
        "far",
        "near",
        "zoom",
        "filmGauge",
        "filmOffset",
        "focus",
      ].forEach((attr) => {
        if (attr in config) {
          attrs[attr] = config[attr];
        }
      });
      Object.assign(camera, attrs);

      // Update the camera position
      if (config.position) {
        const pos = config.position;
        camera.position.set(pos[0], pos[1], pos[2]);
      }
      camera.lookAt(new THREE.Vector3(0, 0, 0));
      console.log("Updated camera", config, camera);
      if (camera.view) {
        camera.updateProjectionMatrix();
      }
    },
    setAmbientLight: (sceneArg, ambientLight) => {
      console.log("ambient light", sceneArg, ambientLight);
      if (sceneArg != null) {
        // Deleting existing Ambient lights
        // sceneArg.children.forEach((obj) => {
        //   if (obj.name === THREEJS_NAMES.AMBIENT_LIGHT) sceneArg.remove(obj);
        // });
        // Adding the new light
        if (!isEmpty(ambientLight)) {
          const light = new THREE.AmbientLight(
            ambientLight.color,
            ambientLight.intensity
          );
          light.name = THREEJS_NAMES.AMBIENT_LIGHT;
          sceneArg.add(light);
          // gui.add(light,'intensity').min(0).max(10).step(0.001).name("Ambient Light Intensity")
        }
      }
    },
    setToneMapping: (rendererArg, toneMapping) => {
      if (!rendererArg) return;
      rendererArg.toneMapping = THREE.NoToneMapping;
      if (!toneMapping) return;
      if ("enableToneMapping" in toneMapping && toneMapping.enableToneMapping) {
        if ("type" in toneMapping) {
          rendererArg.toneMapping = toneMapping.type;
          rendererArg.toneMappingExposure = toneMapping.exposure;
        }
      }
    },
    setDirectionalLights: (sceneArg, directionalLights) => {
      console.log("setting direactional lights", directionalLights);
      if (sceneArg != null) {
        // Deleting existing directional lights
        sceneArg.children.forEach((obj) => {
          if (obj.name === THREEJS_NAMES.DIRECTIONAL_LIGHT)
            sceneArg.remove(obj);
        });
        // Adding new ones
        if (directionalLights != null) {
          directionalLights.forEach((config) => {
            const light = new THREE.DirectionalLight(config.color, 0);
            light.position.set(0, 3, 0);
            light.name = THREEJS_NAMES.DIRECTIONAL_LIGHT;
            light.customId = config.customId;
            light.castShadow = config.castShadow;
            // console.log("bangalore",boxSize);
            // const maxSide = Math.max(boxSize.X,Math.max(boxSize.Y,boxSize.Z));
            const maxSide = 6;
            if (light.castShadow) {
              light.shadow.bias = -0.0001;
              // light.shadow.normalBias = 0.05
              light.shadow.mapSize.width = 1024 * 4;
              light.shadow.mapSize.height = 1024 * 4;
              light.shadow.camera.far = 12;
              light.shadow.camera.near = -1;
              light.shadow.camera.bottom = -maxSide / 2;
              light.shadow.camera.top = maxSide / 2;
              light.shadow.camera.left = -maxSide / 2;
              light.shadow.camera.right = maxSide / 2;
              light.shadow.radius = 50;
              light.shadow.blur = 30;
            }
            // sceneArg.add(new THREE.CameraHelper(light.shadow.camera));
            shadowLight = light;
            sceneArg.add(light);
            sceneArg.add(light.target);
            const light1 = new THREE.DirectionalLight(
              config.color,
              config.intensity
            );
            light1.position.set(
              config.position[0],
              config.position[1],
              config.position[2]
            );
            sceneArg.add(light1);
            sceneArg.add(light1.target);
            // gui.add(light,'intensity').min(0).max(10).step(0.001).name("Directional Light Intensity")
            // gui.add(light.position,'x').min(-5).max(10).step(0.001).name("lightX")
            // gui.add(light.position,'y').min(-5).max(10).step(0.001).name("lightY")
            // gui.add(light.position,'z').min(-5).max(10).step(0.001).name("lightZ")
            // gui.add(light.shadow.camera,'visible')
          });
        }
      }
    },
    addEnvironmentLight,
    updateEnvironmentLight: addEnvironmentLight,
    // updateAmbientLight: (sceneArg, ambientLightConfig) => {
    //   console.log("ambient light", sceneArg, ambientLightConfig);
    //   if (sceneArg != null) {
    //     // Deleting existing Ambient lights
    //     // sceneArg.children.forEach((obj) => {
    //     //   if (obj.name === THREEJS_NAMES.AMBIENT_LIGHT) sceneArg.remove(obj);
    //     // });
    //     // Adding the new light
    //     if (!isEmpty(ambientLightConfig)) {
    //       const light = new THREE.AmbientLight(
    //         ambientLightConfig.color || "#fff",
    //         ambientLightConfig.intensity
    //       );
    //       light.name = THREEJS_NAMES.AMBIENT_LIGHT;
    //       sceneArg.add(light);
    //       // gui.add(light,'intensity').min(0).max(10).step(0.001).name("Ambient Light Intensity")
    //     }
    //   }
    // },
    updateAmbientLight: (sceneArg, ambientLightConfig) => {
      if (sceneArg?.children && ambientLightConfig) {
        const ambientLight = sceneArg.children.find(
          (objectThree) => objectThree.name === THREEJS_NAMES.AMBIENT_LIGHT
        );
        if (ambientLightConfig?.color) {
          ambientLight.color.setHex(ambientLightConfig.color);
        }
        if (ambientLightConfig?.intensity) {
          ambientLight.intensity = ambientLightConfig.intensity;
        }
      }
    },
    removeHdri: () => {
      scene.environment = null;
    },
    updateRendererSettings: (
      sceneArg,
      rendererArg,
      cameraArg,
      rendererConfig
    ) => {
      if (sceneArg == null || rendererArg == null || cameraArg == null) return;
      Object.assign(rendererArg, rendererConfig);
      rendererArg.render(sceneArg, cameraArg);
    },
    addModelToScene: (modelId, gltfObject, scale) => {
      if (scene != null) {
        // gltfObject.scene.rotation.y = Math.PI/180 *30
        scene.add(gltfObject.scene);
        console.log(gltfObject.scene.position, "gltfposition");
        const box = new THREE.Box3().setFromObject(gltfObject.scene);
        const checkheight = box.max.y + box.min.y;
        let multiplier = -1;
        if (checkheight < 0) {
          multiplier = 1;
          onFloor = false;
        }
        const boxSize = box.getSize(new THREE.Vector3()).multiplyScalar(scale);
        console.log("YYYYYY boxsize", boxSize, checkheight);
        newBoxSize = boxSize;
        // ground
        if (onFloor) {
          const mesh = new THREE.Mesh(
            new THREE.PlaneGeometry(100, 100, 1, 1),
            new THREE.ShadowMaterial({
              color: 0x000000,
              opacity: 0.05,
            })
          );
          mesh.rotation.x = -Math.PI / 2;
          mesh.translateZ(-boxSize.y / 2 - 0.00001);
          mesh.receiveShadow = true;
          scene.add(mesh);
        }
        // if (mesh.material.map) mesh.material.map.anisotropy = 16;
        gltfObject.scene.scale.set(scale, scale, scale);

        // const helper = new THREE.BoxHelper(gltfObject.scene, 0xff0000);
        // console.log(helper, "helper");
        // helper.update();
        // box3.setFromObject(helper); // or from mesh, same answer
        // box3.getSize(size);
        // console.log(size, "helpersize");
        gltfObject.scene.position.set(0, (multiplier * boxSize.y) / 2, 0);
        // If you want a visible bounding box
        // scene.add(helper);
        gltfObject.scene.name = THREEJS_NAMES.MODEL;
        console.log("scene add", gltfObject);
        RaycasterHelper.addObjectForIntersection(modelId, gltfObject.scene);
      }
    },
    centerAndScale,
    removeHelpers: () => {
      const objectArray = [];
      scene.children.forEach((objectThreeD) => {
        console.log("remove helpers", objectThreeD);
        if (
          objectThreeD.name === THREEJS_NAMES.BOX_HELPER ||
          objectThreeD.name === THREEJS_NAMES.AXES_HELPER ||
          objectThreeD.name === THREEJS_NAMES.GRID_HELPER
        ) {
          console.log("remove helpers final", objectThreeD);
          objectArray.push(objectThreeD);
        }
        if (
          objectThreeD.name === THREEJS_NAMES.MODEL ||
          objectThreeD.name === THREEJS_NAMES.DIRECTIONAL_LIGHT
        ) {
          const objectChildArray = [];
          objectThreeD.children.forEach((objectChildren) => {
            if (objectChildren.name === THREEJS_NAMES.AXES_HELPER)
              objectChildArray.push(objectChildren);
          });
          objectChildArray.forEach((obj) => objectThreeD.remove(obj));
        }
      });
      objectArray.forEach((obj) => scene.remove(obj));
      updateHelpers = false;
    },
    setLightCameraPosition: (positionToSet, model) => {
      shadowLight.position.set(
        positionToSet.x,
        shadowLight.position.y,
        positionToSet.z
      );
      shadowLight.target = model.scene;
    },
    addHelpers: () => {
      if (scene == null) return;
      updateHelpers = true;
      const axesHelper = new THREE.AxesHelper(1000);
      axesHelper.name = THREEJS_NAMES.AXES_HELPER;
      scene.add(axesHelper);
      scene.children.forEach((objectThreeD) => {
        if (objectThreeD.name === THREEJS_NAMES.MODEL) {
          const boxHelper = new THREE.BoxHelper(objectThreeD, 0xff0000);
          boxHelper.name = THREEJS_NAMES.BOX_HELPER;
          boxHelper.modelObject = objectThreeD;
          scene.add(boxHelper);
          console.log("adding box helper", boxHelper);
        }
        if (
          [THREEJS_NAMES.MODEL, THREEJS_NAMES.DIRECTIONAL_LIGHT].includes(
            objectThreeD.name
          )
        ) {
          const objectAxesHelper = new THREE.AxesHelper(5);
          objectAxesHelper.name = THREEJS_NAMES.AXES_HELPER;
          objectThreeD.add(objectAxesHelper);
        }
      });
      const gridHelper = new THREE.GridHelper(10, 10);
      gridHelper.name = THREEJS_NAMES.GRID_HELPER;
      scene.add(gridHelper);
      console.log("adding helpers", scene);
    },
    setCameraController: (cameraControllerConfig) => {
      if (scene == null || renderer == null || camera == null) return;
      console.log(
        "setting camera controller",
        cameraControllerConfig,
        camera.position,
        renderer
      );
      orbitControls = new OrbitControls(camera, renderer.domElement);
      console.log(orbitControls, "orbitControls");
      Object.assign(orbitControls, cameraControllerConfig);
      console.log(camera.position.z, "cameraposition");
      orbitControls.maxDistance = camera.position.z;
      orbitControls.minDistance = 0.75 * camera.position.z;
      orbitControls.enableDamping = cameraControllerConfig.enableDamping;
      orbitControls.dampingFactor = cameraControllerConfig.dampingFactor;
      if (!onFloor) orbitControls.maxPolarAngle = Math.PI;
      // CameraControls.install({ THREE });
      // cameraControls = new CameraControls(camera, renderer.domElement);
      // Object.assign(cameraControls,cameraControllerConfig);
      // cameraControls.maxPolarAngle = Math.PI / 2;
      // cameraControls.maxDistance =20
    },
    canvasResizeContainer: windowResizeListener,
    windowResizeListener,
  };
};
const ThreejsScene = mod();

export default ThreejsScene;
